import { render } from "./CaptureAdditionalInformation.vue?vue&type=template&id=0af0c81e&scoped=true"
import script from "./CaptureAdditionalInformation.vue?vue&type=script&lang=js"
export * from "./CaptureAdditionalInformation.vue?vue&type=script&lang=js"

import "./CaptureAdditionalInformation.vue?vue&type=style&index=0&id=0af0c81e&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0af0c81e"]])

export default __exports__